import { render, staticRenderFns } from "./orderDifotList.vue?vue&type=template&id=0616843c&"
import script from "./orderDifotList.vue?vue&type=script&lang=js&"
export * from "./orderDifotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports